module.exports = __webpack_public_path__ + "img/normal.7ab05b72.svg";